import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./ProductsPage.css";

const ProductsPage = () => {
  const { categoryId } = useParams();
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [wishlist, setWishlist] = useState([]);

  const categoryNames = {
    1: "Luggage Bags",
    2: "Hard Luggage Bags",
    3: "Travel Bags",
    4: "School Bags",
    5: "Office Bags",
    6: "Ladies Purses",
  };
  const categoryName = categoryNames[categoryId] || "Products";

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
      const url = `https://kothari-international-server.onrender.com/api/products/category/${encodeURIComponent(
        categoryName
      )}`;
          console.log('Fetching from:', url); // Debug log

          const response = await fetch(url);
              console.log('Response status:', response.status); // Debug log

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      console.error('Error details:', errorData);
      throw new Error(`Failed to fetch products (status: ${response.status})`);
    }
        const data = await response.json();
        // Backend already formats price as integer and rating as float
        setProducts(data);
      } catch (error) {
        console.error("Error fetching products:", error);
        setProducts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [categoryId, categoryName]);

  const toggleWishlist = (productId) => {
    setWishlist((prev) =>
      prev.includes(productId) ? prev.filter((id) => id !== productId) : [...prev, productId]
    );
  };

  const handleProductClick = (productId) => {
    navigate(`/product/${productId}`);
  };

  const addToCart = (product) => {
    const cart = JSON.parse(localStorage.getItem("cart") || "[]");
    const existingItemIndex = cart.findIndex((item) => item.id === product.id);
    if (existingItemIndex !== -1) {
      cart[existingItemIndex].quantity += 1;
    } else {
      cart.push({ ...product, quantity: 1 });
    }
    localStorage.setItem("cart", JSON.stringify(cart));
    window.dispatchEvent(new Event("storageUpdate"));
    alert(`${product.name} added to cart!`);
  };

  // Extracted rendering logic to fix SonarQube issue
  const renderProducts = () => {
    if (loading) {
      return Array.from({ length: 4 }).map((_, index) => (
        <div key={index} className="product-card skeleton">
          <div className="product-image-container skeleton-image"></div>
          <div className="product-info">
            <div className="skeleton-text"></div>
            <div className="skeleton-text short"></div>
            <div className="skeleton-text price"></div>
            <div className="skeleton-button"></div>
          </div>
        </div>
      ));
    }

    if (products.length === 0) {
      return <p>No products available in this category.</p>;
    }

    return products.map((product) => (
      <div key={product.id} className="product-card">
        <div className="product-image-container" onClick={() => handleProductClick(product.id)}>
          <img
            src={product.image}
            alt={product.name}
            className="product-image"
          />
          <div className="product-badge">New</div>
          <button
            className={`wishlist-button ${wishlist.includes(product.id) ? "active" : ""}`}
            onClick={(e) => {
              e.stopPropagation();
              toggleWishlist(product.id);
            }}
          >
            {wishlist.includes(product.id) ? "❤️" : "♡"}
          </button>
        </div>
        <div className="product-info">
          <h3 className="product-title">{product.name}</h3>
          <div className="product-price">₹{product.price}</div>
          <button className="add-to-cart-btn" onClick={() => addToCart(product)}>
            Add to Cart
          </button>
        </div>
      </div>
    ));
  };

  return (
    <div className="products-page">
      <div className="products-header">
        <h1>{categoryName}</h1>
      </div>
      <div className="products-grid">
        {renderProducts()}
      </div>
    </div>
  );
};

export default ProductsPage;